import { render, staticRenderFns } from "./ExchangeCodeReceivedSuccessfully.vue?vue&type=template&id=1fcf5aa5&scoped=true"
import script from "./ExchangeCodeReceivedSuccessfully.vue?vue&type=script&lang=js"
export * from "./ExchangeCodeReceivedSuccessfully.vue?vue&type=script&lang=js"
import style0 from "./ExchangeCodeReceivedSuccessfully.vue?vue&type=style&index=0&id=1fcf5aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf5aa5",
  null
  
)

export default component.exports